import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  id: string;
}
export const useSetCustomsControl = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: HookProps) => {
      await request({
        path: `declarations/${id}/set-customs-control`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
